// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page-layout .sidebar-left,
.settings-page-layout .sidebar-right {
  width: 100%;
  max-width: 250px;
  display: none;
}
@media (min-width: 992px) {
  .settings-page-layout .sidebar-left,
  .settings-page-layout .sidebar-right {
    display: block;
  }
}
.settings-page-layout .content-layout {
  display: flex;
  gap: 5px;
}
.settings-page-layout .content-layout .img-con span {
  width: 40px;
  height: 40px;
  background-color: #f0f0f0;
  display: inline-block;
  vertical-align: top;
}
.settings-page-layout .content-layout .text-con {
  flex: 1;
  gap: 5px;
}
.settings-page-layout .content-layout .text-con span {
  height: 10px;
  background-color: #f0f0f0;
}
.settings-page-layout .content-layout.content-layout-1, .settings-page-layout .content-layout.content-layout-2, .settings-page-layout .content-layout.content-layout-3 {
  flex-direction: column;
}
.settings-page-layout .content-layout.content-layout-4, .settings-page-layout .content-layout.content-layout-5, .settings-page-layout .content-layout.content-layout-6 {
  flex-direction: column-reverse;
}
.settings-page-layout .content-layout.content-layout-1 .img-con, .settings-page-layout .content-layout.content-layout-4 .img-con {
  text-align: left;
}
.settings-page-layout .content-layout.content-layout-1 .text-con, .settings-page-layout .content-layout.content-layout-4 .text-con {
  align-items: start;
}
.settings-page-layout .content-layout.content-layout-2 .img-con, .settings-page-layout .content-layout.content-layout-5 .img-con {
  text-align: center;
}
.settings-page-layout .content-layout.content-layout-2 .text-con, .settings-page-layout .content-layout.content-layout-5 .text-con {
  align-items: center;
}
.settings-page-layout .content-layout.content-layout-3 .img-con, .settings-page-layout .content-layout.content-layout-6 .img-con {
  text-align: right;
}
.settings-page-layout .content-layout.content-layout-3 .text-con, .settings-page-layout .content-layout.content-layout-6 .text-con {
  align-items: end;
}
.settings-page-layout .content-layout.content-layout-7 .img-con, .settings-page-layout .content-layout.content-layout-8 .img-con, .settings-page-layout .content-layout.content-layout-9 .img-con, .settings-page-layout .content-layout.content-layout-10 .img-con, .settings-page-layout .content-layout.content-layout-11 .img-con, .settings-page-layout .content-layout.content-layout-12 .img-con {
  display: inline-block;
}
.settings-page-layout .content-layout.content-layout-7, .settings-page-layout .content-layout.content-layout-8, .settings-page-layout .content-layout.content-layout-9 {
  flex-direction: row;
}
.settings-page-layout .content-layout.content-layout-10, .settings-page-layout .content-layout.content-layout-11, .settings-page-layout .content-layout.content-layout-12 {
  flex-direction: row-reverse;
}
.settings-page-layout .content-layout.content-layout-10 .text-con, .settings-page-layout .content-layout.content-layout-11 .text-con, .settings-page-layout .content-layout.content-layout-12 .text-con {
  align-items: end;
}
.settings-page-layout .content-layout.content-layout-7 .img-con, .settings-page-layout .content-layout.content-layout-10 .img-con {
  align-self: flex-start;
}
.settings-page-layout .content-layout.content-layout-8 .img-con, .settings-page-layout .content-layout.content-layout-11 .img-con {
  align-self: center;
}
.settings-page-layout .content-layout.content-layout-9 .img-con, .settings-page-layout .content-layout.content-layout-12 .img-con {
  align-self: flex-end;
}/*# sourceMappingURL=Settings.css.map */`, "",{"version":3,"sources":["webpack://./src/pages/Settings/Settings.scss","webpack://./src/pages/Settings/Settings.css"],"names":[],"mappings":"AAEI;;EAEI,WAAA;EACA,gBAAA;EACA,aAAA;ACDR;ADGQ;EANJ;;IAOQ,cAAA;ECCV;AACF;ADEI;EACI,aAAA;EACA,QAAA;ACAR;ADGY;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;ACDhB;ADKQ;EACI,OAAA;EACA,QAAA;ACHZ;ADIY;EACI,YAAA;EACA,yBAAA;ACFhB;ADMQ;EAGI,sBAAA;ACNZ;ADSQ;EAGI,8BAAA;ACTZ;ADcY;EACI,gBAAA;ACZhB;ADeY;EACI,kBAAA;ACbhB;ADmBY;EACI,kBAAA;ACjBhB;ADoBY;EACI,mBAAA;AClBhB;ADwBY;EACI,iBAAA;ACtBhB;ADwBY;EACI,gBAAA;ACtBhB;ADkCY;EACI,qBAAA;AChChB;ADqCQ;EAGI,mBAAA;ACrCZ;ADwCQ;EAGI,2BAAA;ACxCZ;ADyCY;EACI,gBAAA;ACvChB;AD6CY;EACI,sBAAA;AC3ChB;ADgDY;EACI,kBAAA;AC9ChB;ADmDY;EACI,oBAAA;ACjDhB,CAAA,uCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
